import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="page" style={{ padding: 40 }}>
      <h1>Page not found</h1>
      <p>
        <Link to="/">Back to the dashboard</Link>
      </p>
    </div>
  );
}
